<template lang="pug">
  .content.background
    .row.body-login.card
      .col-md-12.body-login-mobile
        .box-login
          div.text-center
            img.lg-img(:src="logo"  :style="step == 2 ? 'margin-bottom: 0px!important;':''")
          .p-fluid.lg-custom-card-content
            .p-field(v-if="step == 1")
              //- label(for="phone_number") Tài khoản
              InputText(id="phone_number" name="phone_number" v-model="phone_number" type="text" placeholder="Số điện thoại")
              i(class="material-icons lg-icon-account")
                span(class="pi pi-user")
              small(v-if="errors" class="p-invalid") {{errors}}
            .p-field.txt-center(v-else-if="step == 2")
              p.confirm
                span XÁC THỰC SỐ ĐIỆN THOẠI
              label Mã xác thực được gửi qua SMS đến số điện thoại
              p.phone
                span {{phone_number}}
              .box-input-number
                InputNumber.custom-input(id="input_1" ref="input_1" v-model="arrCodes[0]" :min="-1" :max="10" @input="changeInput($event, 1)")
                InputNumber.custom-input(id="input_2" ref="input_2" v-model="arrCodes[1]" :min="-1" :max="10" @input="changeInput($event, 2)")
                InputNumber.custom-input(id="input_3" ref="input_3" v-model="arrCodes[2]" :min="-1" :max="10" @input="changeInput($event, 3)")
                InputNumber.custom-input(id="input_4" ref="input_4" v-model="arrCodes[3]" :min="-1" :max="10" @input="changeInput($event, 4)")
                InputNumber.custom-input(id="input_5" ref="input_5" v-model="arrCodes[4]" :min="-1" :max="10" @input="changeInput($event, 5)")
                InputNumber.custom-input(id="input_6" ref="input_6" v-model="arrCodes[5]" :min="-1" :max="10" @input="changeInput($event, 6)")
              small(v-if="errors" class="p-invalid" v-html="errors") 
              p.display-seconds Mã có hiệu lực trong 
                span(:class="[(currentSeconds <= warning_time) ? 'color-red' : '']") {{ $myConstants.twoDigits(minutes) }}:{{ $myConstants.twoDigits(seconds)}}s
              .refresh-sms.disabled(v-if="currentSeconds > warning_time && !isResend") 
                span Gửi lại mã xác thực 
                  img(:src="send")
              .refresh-sms(v-else @click="sendSMS") 
                span Gửi lại mã xác thực 
                  img(:src="send_active")
            div.form-group.text-center.mb-0(:class="step == 1 ? 'mt-4' : ''")
              button#clickPhone.btn.btn-custom(v-if="step == 1 " @click='submitPhone' :class="[(key_submit_login == true) ? 'disabled' : '']") Tiếp theo
              button.btn.btn-custom.disabled(v-else-if="step == 2 && lengthCode < 6" ) Đăng nhập
              button#clickSubmit.btn.btn-custom(v-else-if="step == 2 && lengthCode >= 6" @click='submitFormLogin'  :class="[(key_submit_verify_otp == true) ? 'disabled' : '']") Đăng nhập
              
</template>

<script>
import DataServices from '@/core/DataServices'
import Api from '@/services'
export default {
  name: 'Login',
  data() {
    return {
      errors: '',
      phone_number: '',
      phone_convert: '',
      logo: '../../../assets/images/logo-login.png',
      send: '../../../assets/images/send.png',
      send_active: '../../../assets/images/send_active.png',
      step: 1,
      count: 0,
      expired_time: 0,
      warning_time: 0,
      secondsLabel: '',
      arrCodes: [],
      isResend: false,
      lengthCode: 0,
      key_submit_login:false,
      key_submit_verify_otp:false
    }
  },
  
  async mounted() {
    if (this.step == 1) {
      const input = document.getElementById('phone_number');
      input.focus();
      input.select();
    }
    let data = localStorage.getItem('phone_number');
    if (data != undefined && data != null) {
      this.phone_number = data;
    }
    window.scrollTo(0, 0);
    this.enterClickSumit();
  },
  computed: {
    currentSeconds() {
      return (this.minutes*60 + this.seconds)
    },
    seconds() {
      return (this.expired_time - this.count) % 60;
    },
    minutes() {
      return Math.trunc((this.expired_time - this.count) / 60) % 60;
    }
  },
  methods: {
    enterClickSumit() {
      var input = document.getElementById('phone_number');
      input.addEventListener("keyup", function(event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          document.getElementById("clickPhone").click();
        }
      });
    },
    changeInput($event, index) {
      if ($event != null && $event !== '') {
        index ++;
        if (index < 7) {
          const input = document.getElementById('input_' + index);
          input.focus();
          input.select();
        }
      } else {
        index--;
        if (index < 1) index = 1;
        
        const input = document.getElementById('input_' + index);
        input.focus();
        input.select();
      }
      this.lengthCode = this.arrCodes.join('').length;
    },
    async sendSMS() {
      var that = this;
      this.phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
      var payload = JSON.stringify({phone: this.phone_convert, isWeb: true});
      await Api.post('/sms/send', payload).then(() => { 
        that.step = 2;
        if (that.isResend) {
          that.arrCodes = [];
          that.errors = '';
          that.isResend = false;
        }
        this.key_submit_login=false;
      })
      .catch(error => {
        that.errors = 'Lỗi từ bên twilio mã lỗi: ' + error.response.data.message;
        this.key_submit_login=false;
      });
      this.count = 0;
    },
    async processVerify(results) {
      var that = this;
      var vm = this;
      if (results != undefined && results != null) {
        this.isResend = true;
        if (results.status == 200) {
          // lưu lại cho những lần sau
          localStorage.setItem('phone_number', this.phone_number);
          localStorage.setItem('isLoggedIn', true);
          this.$store.commit('setLoading', false);
          setTimeout(async function(){
            var url = await that.urlDataRedirect(that.phone_number);
            if (url != '') that.redirectUrl(url);
            else that.redirectUrl('/admin/config');
            vm.key_submit_verify_otp=false;
          }, 1000);
        }else {
          that.key_submit_verify_otp=false;
        }
      }else {
        that.key_submit_verify_otp=false;
      }
    },
    redirectUrl(url) {
      let r = this.$router.resolve({ path: url});
      window.location.assign(r.href)
    },
    async processError(error) {
      if (error.response.data.status == 400) {
        if (error.response.data.message == 'MISMATCH_PARAMS_ERR') {
          this.errors = 'Vui lòng nhập số điện thoại';
        } else if (error.response.data.message == 'NOT_FOUND_ERR') {
          this.errors = 'Mã xác thực không đúng<br/>Vui lòng thử lại hoặc nhấn "Gửi lại mã xác thực';
          this.isResend = true;
        } else if (error.response.data.message == 'INVALID_CODE_ERR') {
          this.errors = 'Mã xác thực không đúng<br/>Vui lòng thử lại hoặc nhấn "Gửi lại mã xác thực"';
          this.isResend = true;
        } else if (error.response.data.message == 'EXPIRED_TIME_ERR') {
          this.errors = 'Mã xác thực đã hết hiệu lực, vui lòng nhấn "Gửi lại mã xác thực"';
          this.isResend = true;
        } else this.errors = error.response.data.message;
      } else this.errors = error.response.data.message;
    },
    async verifySMS() {
      //key_submit_verify_otp
      this.$store.commit('setDataLoading', {icon: true});
      this.$store.commit('setLoading', true);
      var that = this;
      var vm = this;
      if (that.key_submit_verify_otp == true){
        //console.log("yyyy")
        return false;
      }
      that.key_submit_verify_otp=true;
      this.phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
      var codeVerify = this.arrCodes.join('');
      var payload = JSON.stringify({phone: this.phone_convert, code: codeVerify});
      await Api.post('/sms/verify', payload)
      .then(async (response) => {
        await that.processVerify(response.data);
      })
      .catch(async (error) => {
        await that.processError(error);
        that.$store.commit('setLoading', false);
        vm.key_submit_verify_otp=false;
      });
    },
    async getSettings() {
      var variables = {
        where_key: {
          key: {'_in': ['SMS_EXPIRED_TIME', 'SMS_WARNING_TIME'] }
        },
        orderBy: {key: 'asc'} 
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), 'fields' : 'value'});
      if (data != undefined && data != null) {
        var list = data[Object.keys(data)];
        if (list != undefined && list != null) {
          this.expired_time = parseInt(list[0].value) - 1;
          this.warning_time = parseInt(list[1].value);
          if (this.expired_time != undefined && this.warning_time != undefined) {
            await this.sendSMS();
            if (this.errors.length == 0) {
              window.setInterval(() => {
                this.count++;
                if (this.currentSeconds <= 0) {
                  this.errors = 'Mã xác thực đã hết hiệu lực, vui lòng nhấn "Gửi lại mã xác thực"';
                  this.isResend = true;
                  this.key_submit_login=false;
                }
              },1000);
            }
          }
        }
      }
    },
    async submitPhone() {
      this.step = 1;
      if (this.key_submit_login == true){
        //console.log("yyyy")
        return false;
      }
      this.key_submit_login=true;
      this.errors = '';
      if (this.phone_number === '') {
        this.errors = 'Vui lòng nhập số điện thoại';
        this.key_submit_login=false;
      } else if (this.phone_number.length != 10) {
        this.errors = 'Số điện thoại không đúng, vui lòng thử lại';
        this.key_submit_login=false;
      } else {
        this.$store.commit('setDataLoading', {icon: true});
        this.$store.commit('setLoading', true);
        this.phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
        var variables = {
          where_key: {
            phone_number: {'_eq': this.phone_convert },
            is_enabled: {'_eq': true},
            user_type: {'_gt': 1}
          }
        }
        var data = await DataServices.getList('users', {"variables": JSON.stringify(variables), 'fields' : 'id status'});
        if (data != undefined && data != null) {
          var list = data[Object.keys(data)];
          if (list != undefined && list != null && Array.isArray(list) && list.length) {
            await this.getSettings();
          } else{
            this.errors = 'Tài khoản chưa được cấp quyền truy cập';
            this.key_submit_login=false;
          }
        } else{
          this.errors = 'Tài khoản chưa được cấp quyền truy cập';
          this.key_submit_login=false;
        }
        this.$store.commit('setLoading', false);
      }
    },
    async submitFormLogin() {
      if (this.arrCodes.length > 0) {
        await this.verifySMS();
      }
    },
    async urlDataRedirect(phone_number) {
      let phone_convert = this.$myConstants.replaceAt(phone_number, 0, '+84');
      var variables = {
        where_key: {
          phone_number: {'_eq': phone_convert},
          status: {'_eq': 1},
          is_phone_verified: {'_eq': true},
          // is_blocked: {'_eq': false},
          user_type: {'_gt': 1}
        }
      }
      var dtData = await DataServices.getList('users', {"variables": JSON.stringify(variables), 'fields' : 'id users_token { token } user_type roles { permissions { permission { config } } }'});
     
      if (dtData != undefined && dtData != null) {
        var list = dtData[Object.keys(dtData)];
        if (list != undefined && list != null && Object.keys(list).length > 0) {
          var lists = list[0];
          if (lists.user_type != undefined) {
            var token  = '';
            if (lists.users_token != undefined && Object.keys(lists.users_token).length > 0 ) {
              token = (lists.users_token[0].token != undefined && lists.users_token[0].token != null) ? lists.users_token[0].token : '';
            }
            if(token == '' && Number(lists.id) > 0) {
              // tạo token khi thêm tài khoản
              var payloadData = {user_id: lists.id}; 
              await Api.post('/auth/update-token', payloadData);
            }
            if (lists.user_type == 3) return '/admin/config';
            else {
              //lấy role của user
              if (lists && Object.keys(list).length && lists.roles != undefined && lists.roles != null && 
              lists.roles.permissions != undefined && lists.roles.permissions != null) {
                // lấy danh sách permission
                var permissions = lists.roles.permissions;
                if (permissions) {
                  var lstPermissions = permissions.filter(a => a != undefined && Object.keys(a).length);
                  lstPermissions = lstPermissions.filter(b => Object.keys(b.permission).length && b.permission.config != undefined && 
                  Object.keys(b.permission.config).length && 
                  b.permission.config.action != undefined && Object.keys(b.permission.config.action) && (b.permission.config.action  == 'list' || b.permission.config.action == 'all'));
                  if (lstPermissions && Object.keys(lstPermissions).length) {
                    var url = (lstPermissions[0].permission.config.controller != undefined && lstPermissions[0].permission.config.controller != '') ? lstPermissions[0].permission.config.controller : '/admin';
                    return url;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
:root {
  --color-lg-fb: #3b5998;
  --color-lg-gg: #da4837;
  --color-lg-yellow: #ffd311;
}
.body-login { width: 720px;  border-radius: 5px;  height: 440px; background: #fff; margin: 0 auto;  position: absolute;left: 50%; top: 50%; -webkit-transform: translate(-50%, -50%); transform: translate(-50%, -50%); border: 1px solid rgba(188, 188, 188, 1);
  .lg-img { background: transparent; /*margin-bottom: 20px;*/margin-bottom: 10px; width: 150px;/*width: 325px;*/}
  .body-login-mobile{position: absolute;left: 50%; top: 50%; -webkit-transform: translate(-50%, -50%); transform: translate(-50%, -50%);
    .box-login{ padding: 30px; margin: 0 auto;
      .lg-custom-card-content {width: 410px; margin: 0 auto;
        .p-field {position: relative;
          .p-inputtext{border-radius: 5px; padding: 10px;}
          .lg-icon-account{ margin-top: -39px; display: block; position: absolute;right: 10px;}
          .confirm{margin-bottom: 10px;
            span{font-weight: 700; color: #0066FF; font-size: 18px;}
          }
          .p-invalid{margin-bottom: 10px; }
          .phone{font-weight: 700; font-style: normal; font-size: 15px; color: #666666; margin-bottom: 10px;}
          .display-seconds {margin-bottom: 10px; 
            span{color: #00CC00;font-weight: 700;
              &.color-red{color: #f00;}
            }
          }
          .refresh-sms{ cursor: pointer;
            &.disabled{ 
              span{color: #999999;}
            }
            span{font-weight: 700; font-size: 14px; color: #0066FF;
              img {padding-left: 10px; font-weight: 700;}
            }
          }
          .box-input-number { margin-bottom: 15px;
            .custom-input{width: 48px;height: 43px; border-width: 0px;  padding:0 5px; 
              input{border-radius: 0; font-weight: 400; font-size: 25px; text-decoration: none;color: #000000; text-align: center; border-color: transparent; outline-style: none; border-bottom: 1px solid #797979;
                &:enabled:focus{box-shadow: none;}
              }
            }
          }
        }
      }
    }
  }
}
.p-invalid{font-size: 14px; color: #FF0000; display: block; text-align: center;  padding-top: 10px;}
.btn-custom{
  background: -webkit-linear-gradient(
270deg
, rgba(0, 102, 255, 1) 0%, rgba(0, 102, 255, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%);
  background: -moz-linear-gradient(180deg, rgba(0, 102, 255, 1) 0%, rgba(0, 102, 255, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%);
  background: linear-gradient(
180deg
, rgba(0, 102, 255, 1) 0%, rgba(0, 102, 255, 1) 0%, rgba(45, 108, 162, 1) 100%, rgba(45, 108, 162, 1) 100%);
  border: 1px solid rgba(40, 94, 142, 1) !important;
  margin-top: 8px !important; cursor: pointer !important; color: #fff; text-transform: uppercase; font-size: 14px; font-family: "adobe-clean", sans-serif; border-radius: 5px; width: 167px; height: 40px;
  &:hover{color: #fff;}
  &.disabled{background: #999999; border: 1px solid #999999 !important;}
}
.loading{z-index: 2000;
  .loading-body{background: #ffff; z-index: 4000; margin: 0 auto; width: 70px; border-radius: 5px; padding: 10px; position: relative; top: 45%; display: flex; align-items: center;
    .p-progress-spinner{width: 50px; height: 50px; margin: 0;}
    span{font-size: 18px;}
  }
}
.txt-center{text-align: center !important;}
.txt-right{text-align: right !important;}
.txt-left{text-align: left !important;}
</style>
